import {library} from '@fortawesome/fontawesome-svg-core'
// We're doing imports like this because I can't get treeshaking to work when importing
// from the main package. The whole icon set is huge, almost a Mb, so we want to treeshake these.
// Solid Icons
import {faAngleRight} from '@fortawesome/free-solid-svg-icons/faAngleRight'
import {faCaretDown} from '@fortawesome/free-solid-svg-icons/faCaretDown'
import {faCaretRight} from '@fortawesome/free-solid-svg-icons/faCaretRight'
import {faCaretUp} from '@fortawesome/free-solid-svg-icons/faCaretUp'
import {faCheck} from '@fortawesome/free-solid-svg-icons/faCheck'
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons/faCheckCircle'
import {faChevronDown} from '@fortawesome/free-solid-svg-icons/faChevronDown'
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons/faChevronLeft'
import {faChevronRight} from '@fortawesome/free-solid-svg-icons/faChevronRight'
import {faChevronUp} from '@fortawesome/free-solid-svg-icons/faChevronUp'
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import {faHdd} from '@fortawesome/free-solid-svg-icons/faHdd'
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons/faInfoCircle'
import {faPlus} from '@fortawesome/free-solid-svg-icons/faPlus'
import {faReply} from '@fortawesome/free-solid-svg-icons/faReply'
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes'
import {faBell} from '@fortawesome/free-solid-svg-icons/faBell'
import {faSearch} from '@fortawesome/free-solid-svg-icons/faSearch'
import {faRedo} from '@fortawesome/free-solid-svg-icons/faRedo'
import {faTrash} from '@fortawesome/free-solid-svg-icons/faTrash'
// Regular Icons
import {faEdit} from '@fortawesome/free-regular-svg-icons/faEdit'

// Every icon that's used in the app needs to be added here.
// This way, the icons are tree shaken, so we only include the ones we need.
export function init() {
    // Solid
    library.add(
        faAngleRight,
        faCaretDown,
        faCaretRight,
        faCaretUp,
        faCheck,
        faCheckCircle,
        faChevronDown,
        faChevronLeft,
        faChevronRight,
        faChevronUp,
        faExclamationTriangle,
        faHdd,
        faInfoCircle,
        faPlus,
        faReply,
        faTimes,
        faBell,
        faSearch,
        faRedo,
        faTrash,
    );
    // Regular
    library.add(
        faEdit,
    );
}